{
  "previous": "이전",
  "next": "다음",
  "complete": "완료",
  "verifyAndCheckIn": "확인 후 체크인",
  "loading": {
    "retrievingLocation": "위치를 가져오는 중...",
    "retrievingWarehouse": "창고 데이터를 가져오는 중..."
  },
  "validation": {
    "fieldRequired": "필수 입력 항목입니다",
    "fieldRequiredWithLabel": "{label}은(는) 필수입니다",
    "phoneInvalid": "유효한 전화번호가 아닙니다",
    "phoneInvalidWithExample": "유효한 전화번호가 아닙니다(예: {example})"
  }
}
